import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
  
    width={37}
    height={42}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      d="M37 23.5c-18.024.263-18.237.476-18.5 18.5-.263-18.024-.476-18.237-18.5-18.5 18.024-.263 18.237-.476 18.5-18.5.263 18.024.476 18.237 18.5 18.5ZM32 4.5c-4.384.064-4.436.116-4.5 4.5-.064-4.384-.116-4.436-4.5-4.5 4.384-.064 4.436-.116 4.5-4.5.064 4.384.116 4.436 4.5 4.5Z"
    />
  </Svg>
)
export default SvgComponent
